import * as React from 'react';
import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavMenuAlt = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M20 5H4v2h16V5ZM4 14.43l16-2.83V9.57L4 12.4v2.03ZM20 17H4v2h16v-2Z"
    />
  </svg>
);
export default SvgNavMenuAlt;
